import React from "react";
import styled from "styled-components";
import DoneIcon from "@mui/icons-material/Done";
import { useDispatch, useSelector } from "react-redux";
import { fiscaisAdd, fiscaisDelete } from "../../../../../Services/cardService";
import { Avatar } from "@mui/material";
const Container = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 0.5rem;
  padding-bottom: 1rem;
`;

const SearchArea = styled.input`
  width: 100%;
  height: 2rem;
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  padding-left: 0.5rem;
  outline: none;
  background-color: rgba(0, 0, 0, 0.02);
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
  &:focus {
    border: 2px solid #0079bf;
    background-color: #fff;
  }
`;

export const Title = styled.div`
  color: #5e6c84;
  margin-top: 0.3rem;
  font-size: 0.85rem;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const FiscaisWrapper = styled.div`
  width: 100%;
  background-color: transparent;
  border-radius: 3px;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  height: 2rem;
  align-items: center;
  padding: 0.5rem;
  position: relative;
  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
`;

export const IconWrapper = styled.div`
  width: fit-content;
  height: fit-content;
  position: absolute;
  right: 0.5rem;
  top: 0.5rem;
`;

const FiscaisName = styled.div``;

const FiscaisComponent = (props) => {
  const dispatch = useDispatch();
  const card = useSelector((state) => state.card);
  const isFiscais = card.fiscais.filter((a) => a.user === props.user).length
    ? true
    : false;    
  const handleClick = async () => {    
    if (isFiscais) {
      await fiscaisDelete(
        card.cardId,
        card.listId,
        card.boardId,
        props.user,
        props.name + " " + props.surname,
        dispatch
      );
    } else {
      await fiscaisAdd(
        card.cardId,
        card.listId,
        card.boardId,
        props.user,
        props.email,
        props.name + " " + props.surname,
        props.color,
        dispatch
      );
    }
  };

  const getInitials = (name) => {
    const parts = name.trim().split(" ");
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  };

  return (
    <FiscaisWrapper onClick={handleClick}>
      <Avatar
        sx={{
          width: 28,
          height: 28,
          bgcolor: props.color,
          fontSize: "0.875rem",
          fontWeight: "800",
        }}
      >
        {getInitials(props.name + " " + props.surname)}
      </Avatar>
      <FiscaisName>
        {props.name} {props.surname} -{" "}
        {getInitials(props.name + " " + props.surname)}
      </FiscaisName>
      {isFiscais && (
        <IconWrapper>
          <DoneIcon fontSize="1rem" />
        </IconWrapper>
      )}
    </FiscaisWrapper>
  );
};

const FiscaisPopover = () => {
  const fiscais = useSelector((state) => state.board.members);

  const sortedFiscais = [...fiscais].sort((a, b) =>
    a.name.localeCompare(b.name, "pt", { sensitivity: "base" })
  );
  return (
    <Container>
      <SearchArea placeholder="Pesquisar..." />
      <Title>Fiscais</Title>
      {sortedFiscais.map((fiscal) => {
        return <FiscaisComponent key={fiscal.user} {...fiscal} />;
      })}
    </Container>
  );
};

export default FiscaisPopover;
